export const tenantsStoreAreAdditionalScriptsLoadedSelector = () => false;
export const isDynamicBundleSelector = () => false;
export const isResellerStoreTypeSelector = () => false;
export const isResellerContractSignedSelector = () => true;
export const isResellerContractPendingSignWidgetShownSelector = state => false;
export const isResellerStoreActiveSelector = () => true;
export const isAllowedToOrderProceedForResellerStoreSelector = () => true;